// Allergen-nøgleord (dansk + engelsk) for EU's 14 store allergener
const ALLERGEN_KEYWORDS = {
  'gluten':        ['gluten', 'hvede', 'wheat', 'rug', 'rye', 'byg', 'barley', 'havre', 'oats', 'spelt', 'kamut', 'dinkel', 'triticum'],
  'milk':          ['mælk', 'milk', 'fløde', 'cream', 'smør', 'butter', 'kasein', 'casein', 'valle', 'whey', 'laktose', 'lactose', 'yoghurt', 'yogurt'],
  'nuts':          ['mandel', 'almond', 'cashew', 'valnød', 'walnut', 'hasselnød', 'hazelnut', 'pistacie', 'pistachio', 'macadamia', 'pekan', 'pecan', 'paranød', 'brazil nut'],
  'peanuts':       ['jordnød', 'peanut', 'arachide'],
  'eggs':          ['æg,', 'æg ', 'egg', 'æggeblomme', 'albumin', 'lysozym', 'lysozyme', 'ovalbumin'],
  'soybeans':      ['soja', 'soy', 'soya', 'tofu', 'edamame', 'miso', 'tempeh'],
  'fish':          ['fisk', ' fish', 'laks', 'salmon', 'tun,', 'tuna', 'torsk', 'cod', 'makrel', 'mackerel', 'ansjos', 'anchovy'],
  'crustaceans':   ['rejer', 'shrimp', 'krabbe', 'crab', 'hummer', 'lobster', 'jomfruhummer', 'langoustine'],
  'sesame-seeds':  ['sesam', 'sesame'],
  'celery':        ['selleri', 'celery'],
  'mustard':       ['sennep', 'mustard'],
  'sulphites':     ['sulfit', 'sulphite', 'sulfite', 'svovldioxid', 'sulphur dioxide', 'e220', 'e221', 'e222', 'e223', 'e224'],
  'molluscs':      ['bløddyr', 'mollusc', 'mollusk', 'østers', 'oyster', 'musling', 'mussel', 'blækhus', 'squid', 'snegl', 'snail'],
  'lupin':         ['lupin', 'lupine'],
};

const LABEL_KEYWORDS = {
  'vegetarian':   ['vegetarisk', 'vegetarian'],
  'vegan':        ['vegansk', 'vegan', 'plantebaseret', 'plant-based'],
  'lactose-free': ['laktosefri', 'lactose-free', 'laktosfri', 'laktose fri', 'lactosefri'],
};

export function parseAllergens(text) {
  const lower = text.toLowerCase();
  const allergens = [];
  const labels = [];
  for (const [key, words] of Object.entries(ALLERGEN_KEYWORDS)) {
    if (words.some(w => lower.includes(w))) allergens.push(key);
  }
  for (const [key, words] of Object.entries(LABEL_KEYWORDS)) {
    if (words.some(w => lower.includes(w))) labels.push(key);
  }
  return { allergens, labels };
}

export const ALL_ALLERGENS = [
  { key: 'gluten',       label: 'Gluten',      emoji: '🌾' },
  { key: 'milk',         label: 'Mælk',        emoji: '🥛' },
  { key: 'nuts',         label: 'Nødder',      emoji: '🥜' },
  { key: 'peanuts',      label: 'Jordnødder',  emoji: '🥜' },
  { key: 'eggs',         label: 'Æg',          emoji: '🥚' },
  { key: 'soybeans',     label: 'Soja',        emoji: '🫘' },
  { key: 'fish',         label: 'Fisk',        emoji: '🐟' },
  { key: 'crustaceans',  label: 'Skaldyr',     emoji: '🦐' },
  { key: 'sesame-seeds', label: 'Sesamfrø',    emoji: '🌱' },
  { key: 'celery',       label: 'Selleri',     emoji: '🥬' },
  { key: 'mustard',      label: 'Sennep',      emoji: '🌿' },
  { key: 'sulphites',    label: 'Sulfitter',   emoji: '⚗️' },
  { key: 'molluscs',     label: 'Bløddyr',     emoji: '🐚' },
  { key: 'lupin',        label: 'Lupin',       emoji: '🌾' },
];

export const ALL_LABELS = [
  { key: 'vegetarian',   label: 'Vegetarisk',  emoji: '🥕' },
  { key: 'vegan',        label: 'Vegansk',     emoji: '🌿' },
  { key: 'lactose-free', label: 'Laktosefri',  emoji: '🫙' },
];
